import { I18nService } from '@personal-area/global/i18n';
import { Component } from '@angular/core';

export interface Slide {
  title: string;
  text: string;
  linkText: string;
  imageSrc: string;
  link?: string;
  origin?: string;
  routerLink?: string;
}

// not a real abstract 'cause is used as an instance for global project ->
// later we gonna make a global-related independent component so this one can become a full-fledged abstract
@Component({ template: '' })
export class AbstractInformationWidgetComponent {

  public daysTillGone: number;

  protected _staticSlides: Slide[];
  protected _slides: Slide[];
  protected _imagesFolder: string;

  constructor(
    private _i18nService: I18nService
  ) {
    this._imagesFolder = './assets/img/icons/information-widget/';

    this._slides = [];
    this._staticSlides = [
      { name: 'analysis', url: '/analytics/articles' },
      { name: 'news', url: '/analytics/news' },
      { name: 'calendar', url: '/analytics/calendar' },
      { name: 'tips', url: '/analytics/tips' }
    ].map(item => ({
        title: `promotion.${item.name}.title`,
        text: `promotion.${item.name}.text`,
        linkText: `promotion.${item.name}.link-text`,
        link: item.url,
        imageSrc: this._imagesFolder + item.name + '.svg',
        origin: window.location.origin
      })
    );

    this._slides = this._staticSlides;
  }

  public get language(): string {
    return this._i18nService.languageA2;
  }

  public get slides(): Slide[] {
    return this._slides;
  }

  public getItemExternalHref(item: Slide): string {
    throw new Error('Abstract method should be implemented!');
  }
}
